import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.timers.js";
import { Core } from "@faire/design-tokens";
import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { isHiddenSection } from "@faire/help-center/consts";
import searchArticles, { QueryParameters as ISearchArticlesRequest } from "@faire/web-api/api/zendesk/articles/search/get";
import { trackHelpCenterSearchArticleKeyboardInput, trackHelpCenterSearchArticleKeyboardInputTraceApiRequestEnd, trackHelpCenterSearchArticleKeyboardInputTraceApiRequestStart, trackHelpCenterSearchArticleKeyboardInputTraceRendered } from "@faire/web-api/events/helpCenter/keyboardInput/searchArticle";
import { trackHelpCenterSearchEnterKeyboardInput } from "@faire/web-api/events/helpCenter/keyboardInput/searchEnter";
import home from "@faire/web-api/routes/support";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import brands from "@faire/web-api/routes/support/brands";
import searchPage from "@faire/web-api/routes/support/search";
import { useStrictLocalization } from "@faire/web/common/localization";
import { SafelySetInnerHTML } from "@faire/web/common/SafelySetInnerHTML";
import { Search } from "@faire/web/slate/icons/foundation/Search";
import { Spacer } from "@faire/web/slate/spacing";
import { useState } from "@faire/web/ui/hooks/useState";
import { Link } from "@faire/web/ui/LinkAnchor";
import get from "lodash/get";
import qs from "query-string";
import * as React from "react";
import { useHistory } from "react-router-dom";
import { IconWrapper, scrollToTopIfNeeded, SearchInput, SearchResult, StyledLoadingSpinner, Wrapper } from "./SearchField.styles";
export var SearchField = function SearchField(_ref) {
  var _history$location2;
  var mini = _ref.mini,
    expanded = _ref.expanded,
    miniInputSize = _ref.miniInputSize,
    isLoading = _ref.isLoading,
    autoFocus = _ref.autoFocus,
    categoryId = _ref.categoryId,
    navigatedFrom = _ref.navigatedFrom,
    sectionFrom = _ref.sectionFrom;
  var listRef = React.useRef(null);
  var itemRef = React.useRef(null);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    searchResult = _useState2[0],
    setSearchResult = _useState2[1];
  var history = useHistory();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    searchIsLoading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    searchValue = _useState6[0],
    setSearchValue = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showResult = _useState8[0],
    setShowResult = _useState8[1];
  var _useState9 = useState(-1),
    _useState10 = _slicedToArray(_useState9, 2),
    selected = _useState10[0],
    setSelected = _useState10[1];
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var abortControllerRef = React.useRef(new AbortController());
  var fetchSearchResults = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var value, abortController, response, result, _getRetailerToken, _getBrandToken;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            value = get(event, "currentTarget.value");
            initSearchState(value);
            if (!(!value || value.length < 3)) {
              _context.next = 6;
              break;
            }
            setSearchResult([]);
            return _context.abrupt("return");
          case 6:
            setLoading(true);
            trackHelpCenterSearchArticleKeyboardInputTraceApiRequestStart();
            if (abortControllerRef.current) {
              abortControllerRef.current.abort();
            }
            abortController = new AbortController();
            abortControllerRef.current = abortController;
            _context.next = 13;
            return searchArticles(ISearchArticlesRequest.build({
              query: value,
              category: categoryId,
              locale: localeString
            }), {
              signal: abortController.signal
            });
          case 13:
            response = _context.sent;
            trackHelpCenterSearchArticleKeyboardInputTraceApiRequestEnd();
            result = get(response, "results", []);
            setSearchResult(result.filter(function (article) {
              return !isHiddenSection(article.section_id) && !article.draft;
            }).map(function (article) {
              var _article$id$toString, _article$id, _article$title, _article$snippet;
              return {
                id: (_article$id$toString = (_article$id = article.id) === null || _article$id === void 0 ? void 0 : _article$id.toString()) !== null && _article$id$toString !== void 0 ? _article$id$toString : "",
                title: (_article$title = article.title) !== null && _article$title !== void 0 ? _article$title : "",
                snippet: (_article$snippet = article.snippet) !== null && _article$snippet !== void 0 ? _article$snippet : ""
              };
            }));
            if (result.length) {
              toggleResult();
              // when we have search result, we track the search input
              trackHelpCenterSearchArticleKeyboardInput(isBrandSearch ? "brand" : "retailer", (_getRetailerToken = getRetailerToken()) !== null && _getRetailerToken !== void 0 ? _getRetailerToken : "", (_getBrandToken = getBrandToken()) !== null && _getBrandToken !== void 0 ? _getBrandToken : "", searchValue, sectionFrom);
            }
            setLoading(false);
            _context.next = 26;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](0);
            setSearchResult([]);
            toggleResult(true);
            setLoading(false);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 21]]);
    }));
    return function fetchSearchResults(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var _onBlur = function onBlur(event) {
    var currentTarget = get(event, "currentTarget");
    setTimeout(function () {
      if (!currentTarget.contains(document.activeElement)) {
        toggleResult(true);
      }
    }, 0);
  };
  var isBrandSearch = React.useMemo(function () {
    var _history$location;
    return ((_history$location = history.location) === null || _history$location === void 0 ? void 0 : _history$location.pathname) === brands() || categoryId === BRANDS_CATEGORY_ID;
  }, [categoryId, (_history$location2 = history.location) === null || _history$location2 === void 0 ? void 0 : _history$location2.pathname]);
  var placeholder = React.useMemo(function () {
    return isBrandSearch ? strictLocalize({
      id: "0/eaku",
      defaultMessage: [{
        "type": 0,
        "value": "Zoek merkgidsen"
      }]
    }) : strictLocalize({
      id: "o6o+fM",
      defaultMessage: [{
        "type": 0,
        "value": "Zoek gidsen voor retailers"
      }]
    });
  }, [isBrandSearch, strictLocalize]);
  var initSearchState = function initSearchState(value) {
    setSearchValue(value);
    setSelected(-1);
  };
  var search = function search() {
    var selectedArticle = searchResult[selected];
    if (selectedArticle) {
      history.push(articlePage(selectedArticle.id));
      resetSearch();
    }
    // TODO: use appHistory.history.push(`${search}?query=${this.searchValue}`); when we get a search page design
  };
  var navigateResult = function navigateResult(event) {
    var keyCode = event.key || event.keyCode;
    if ((keyCode === 40 || keyCode === "ArrowDown") && selected < searchResult.length - 1) {
      setSelected(selected + 1);
    } else if ((keyCode === 38 || keyCode === "ArrowUp") && selected > 0) {
      setSelected(selected - 1);
    } else if ((keyCode === 13 || keyCode === "Enter") && searchValue) {
      var _history$location3;
      if (selected !== -1) {
        search();
      } else if (((_history$location3 = history.location) === null || _history$location3 === void 0 ? void 0 : _history$location3.pathname) !== home()) {
        var _history$location$pat, _history$location4;
        trackHelpCenterSearchEnterKeyboardInput((_history$location$pat = (_history$location4 = history.location) === null || _history$location4 === void 0 ? void 0 : _history$location4.pathname) !== null && _history$location$pat !== void 0 ? _history$location$pat : "");
        history.push("".concat(searchPage(), "?").concat(qs.stringify({
          categoryId: categoryId,
          searchTerm: searchValue
        })));
      }
    }
  };
  var resetSearch = function resetSearch() {
    toggleResult(true);
    setSearchValue("");
    setSelected(-1);
  };
  var toggleResult = function toggleResult(hide) {
    setShowResult(!hide);
  };
  React.useEffect(function () {
    if (itemRef.current && listRef.current) {
      scrollToTopIfNeeded(itemRef.current, listRef.current);
    }
  }, [itemRef, listRef]);
  React.useEffect(function () {
    if (showResult) {
      trackHelpCenterSearchArticleKeyboardInputTraceRendered();
    }
  }, [showResult]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    onBlur: function onBlur(event) {
      return _onBlur(event);
    },
    "$mini": mini,
    "$miniInputSize": miniInputSize,
    "$expanded": expanded
  }, isLoading || searchIsLoading ? ( /*#__PURE__*/React.createElement(StyledLoadingSpinner, {
    size: "small"
  })) : null, /*#__PURE__*/React.createElement(IconWrapper, {
    "$mini": mini
  }, /*#__PURE__*/React.createElement(Search, {
    color: Core.icon.subdued
  })), /*#__PURE__*/React.createElement(SearchInput, {
    "data-test-id": "search-input",
    type: "text",
    autoFocus: autoFocus,
    "$placeholder": isLoading ? "" : placeholder,
    value: searchValue,
    onChange: function onChange(event) {
      return fetchSearchResults(event);
    },
    onFocus: function onFocus() {
      return toggleResult(false);
    },
    onKeyDown: function onKeyDown(event) {
      return navigateResult(event);
    },
    className: "search-help-center",
    "$mini": mini
  }), showResult && !!searchResult.length && ( /*#__PURE__*/React.createElement(SearchResult, {
    ref: listRef,
    "data-test-id": "search-result"
  }, searchResult.map(function (article, index) {
    var _history$location5;
    return /*#__PURE__*/React.createElement("li", {
      key: article.id,
      ref: function ref(_ref3) {
        if (_ref3 && selected === index) {
          itemRef.current = _ref3;
        }
      }
    }, /*#__PURE__*/React.createElement(Link, {
      to: {
        pathname: articlePage(article.id),
        state: {
          navigatedFrom: navigatedFrom,
          articleTitle: article.title,
          pageFrom: (_history$location5 = history.location) === null || _history$location5 === void 0 ? void 0 : _history$location5.pathname,
          sectionFrom: sectionFrom
        }
      },
      onClick: function onClick() {
        toggleResult(true);
        resetSearch();
      },
      className: selected === index ? "search-item-selected" : "",
      onFocus: function onFocus() {
        return setSelected(index);
      }
    }, /*#__PURE__*/React.createElement("h2", null, article.title), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(SafelySetInnerHTML, {
      html: mini ? "".concat(article.snippet.slice(0, 70), "...") : article.snippet,
      tag: "p"
    })));
  }))));
};